import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      // 🔴 UI-FLOOR-1 (s208) — THE SWITCH IS DELIBERATELY LEFT AT 44×24, AND THIS IS THE FINDING.
      //
      // A 44px ::after hit area was built and then MEASURED on /settings before shipping: 6 of the 9
      // switches' hit areas OVERLAPPED each other, because that list has a 40px row pitch and the
      // areas are 44px tall. A click in the 4px seam between two rows would land on whichever
      // painted last — and these are the situation flags that drive section auto-N/A, so a silent
      // mis-toggle turns whole sections off. That is worse than the target it fixes.
      //
      // 🔴 The 44px floor for a switch is therefore NOT a component change — it needs ≥44px of ROW
      // PITCH on every surface that hosts one, which is a spacing decision, not a mechanical one.
      // Recorded rather than forced. Note the control is already 44×24, so it clears WCAG 2.5.8
      // (AA, 24×24); 44×44 is 2.5.5 (AAA). Do not re-add the overlay without fixing the pitch.
      "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
      )}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
